import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class MediaRoute extends RouteBase {
  prefix = 'api.v1.attachments.'

  show(mediaId: number) {
    return this.ziggyRoute('show', mediaId)
  }

  delete(mediaId: number) {
    return this.ziggyRoute('delete', mediaId)
  }
}
